module.exports = "/media/face_a_day_audio.c9190a3b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/face_a_day_audio.mp3
// module id = 287
// module chunks = 0